import GarminConnectBeActiveTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/garmin-conect/triggers/beActive/InstructionsComponent';
import type {GarminConnectBeActiveTriggerStruct} from '@cohort/shared/apps/garmin-connect/triggers/beActive';
import {GarminConnectBeActiveTriggerIntegrationSpec} from '@cohort/shared/apps/garmin-connect/triggers/beActive';
import GarminConnectBeActiveTriggerIntegrationDetailComponent from '@cohort/wallet/apps/garmin-connect/triggerIntegrations/beActive/DetailComponent';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const GarminConnectBeActiveTriggerIntegration: TriggerIntegration<GarminConnectBeActiveTriggerStruct> =
  {
    type: 'verification',
    spec: GarminConnectBeActiveTriggerIntegrationSpec,
    detailsComponent: GarminConnectBeActiveTriggerIntegrationDetailComponent,
    instructionsComponent: GarminConnectBeActiveTriggerIntegrationInstructionsComponent,
    disableExponentialBackoff: true,
  };
